import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    TESTING_DETAIL_FETCH_TRIGGER,
    TestingDetailFetchNormalizedResponse,
    TestingDetailFetchTriggerAction,
    testingDetailFetchApi,
} from "@/mk2/apps/testings/containers/TestingDetail/TestingDetail.actions";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { HistoryAction } from "@/mk2/services/browserHistory";
import { testings_api_testing_get_url } from "@/mk/urls/functions";

const logger = getLogger("bo/TestingDetail.sagas");

interface ApiFetchResponse {
    body: {
        entities: TestingDetailFetchNormalizedResponse["entities"];
        result: TestingDetailFetchNormalizedResponse["result"];
    };
}

function* fetch({
    testingHashtag,
    xhr,
    history,
}: TestingDetailFetchTriggerAction & XHRAction & HistoryAction) {
    yield put(testingDetailFetchApi.request(testingHashtag));

    try {
        const response: ApiFetchResponse = yield call(() =>
            xhr.get(testings_api_testing_get_url(testingHashtag)),
        );

        yield put(
            testingDetailFetchApi.success(testingHashtag, {
                entities: response.body.entities,
                result: response.body.result,
            }),
        );
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, history, logger);
        yield put(testingDetailFetchApi.failure(testingHashtag, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(TESTING_DETAIL_FETCH_TRIGGER, fetch)]);
}
